import { EPIC } from 'core/constants/products'
import isPlanType from 'utils/pivot/plan/isPlanType'

function isEpicPlan<T extends CorePlan>(plan: T): boolean {
  return isPlanType(plan, EPIC)
}

export default isEpicPlan
